/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import BulkNotificationsMailingListsDashboard from "../../../components/BulkNotifications/MailingLists";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const BulkNotificationsMailingList = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.bulkNotifications?.hasMailingListAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <BulkNotificationsMailingListsDashboard ROOT_URL={ROOT_URL} userConfig={userConfig} />
    </>
  );
};

export default BulkNotificationsMailingList;
